export const TYPE_WRAPPER = Symbol('type-wrapper');
//# sourceMappingURL=type-wrapper.const.mjs.map